// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/fon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productDetail {
  width: 100%;
}
.productDetail-bgImage {
  width: 100%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}
.productDetail-bgImage-content {
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.productDetail-bgImage-content img {
  width: 450px;
  height: 450px;
  object-fit: contain;
}
.productDetail-bgImage-content-right {
  display: flex;
  flex-direction: column;
}
.productDetail-bgImage-content-right-title {
  font-size: 36px;
  font-weight: 700;
  color: #fefefe;
  max-width: 615px;
}
.productDetail-bgImage-content-right-descr {
  font-size: 16px;
  font-weight: 400;
  color: #fefefe;
  opacity: 0.8;
  max-width: 616px;
  margin-top: 24px;
}
.productDetail-bgImage-content-right button {
  margin-top: 32px;
  border-radius: 20px;
  padding: 12px 24px;
  border: 0;
  outline: none;
  background-color: #6E00FF;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.productDetail-bgImage-content-right button a {
  text-decoration: none;
}
.productDetail-bgImage-content-right button span {
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
  margin-right: 10px;
}
.productDetail-bgImage-content-right-colors {
  display: flex;
  align-items: center;
  margin-top: 48px;
}
.productDetail-bgImage-content-right-colors-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
}
.productDetail-bgImage-content-right-colors-item-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #4d4c4d;
}
.productDetail-bgImage-content-right-colors-item span {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #fefefe;
}
.productDetail-info {
  padding: 60px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.productDetail-info-text {
  display: flex;
  flex-direction: column;
}
.productDetail-info-text-title {
  font-size: 36px;
  font-weight: 700;
  color: #fefefe;
  max-width: 615px;
}
.productDetail-info-text-descr {
  font-size: 18px;
  font-weight: 400;
  color: #fefefe;
  opacity: 0.8;
  max-width: 616px;
  margin-top: 24px;
}
.productDetail-info img {
  width: 615px;
  height: 500px;
  border-radius: 12px;
  object-fit: contain;
}
.productDetail-characteristics {
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.productDetail-characteristics-title {
  font-size: 36px;
  font-weight: 700;
  color: #fefefe;
}
.productDetail-characteristics-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
}
.productDetail-characteristics-list-item {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #434242;
}
.productDetail-characteristics-list-item span {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
}
.productDetail-characteristics-list-item:first-child {
  border-top: 1px solid #434242;
}
.productDetail-characteristics-list button {
  margin-top: 30px;
  padding: 12px 24px;
  border-radius: 20px;
  border: 1px solid #fefefe;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.productDetail-characteristics-list button span {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
}
.productDetail-characteristics-list button span:first-child {
  font-size: 24px;
  margin-left: 0;
}
.productDetail-slider {
  width: 100%;
  padding: 100px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.productDetail-slider-title {
  font-size: 32px;
  font-weight: 700;
  color: #fefefe;
  text-align: center;
}
.productDetail-slider-descr {
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
  text-align: center;
}

@media (max-width: 576px) {
  .productDetail-bgImage {
    height: auto;
  }
  .productDetail-bgImage-content {
    padding: 20px 0;
    flex-direction: column;
    justify-content: flex-start;
  }
  .productDetail-bgImage-content img {
    width: 150px;
    height: 150px;
  }
  .productDetail-bgImage-content-right-title {
    margin-top: 10px;
    font-size: 22px;
    text-align: center;
  }
  .productDetail-bgImage-content-right-descr {
    font-size: 12px;
    text-align: center;
  }
  .productDetail-bgImage-content-right button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .productDetail-info {
    flex-direction: column;
    padding: 30px 0 0 0;
  }
  .productDetail-info-text-title {
    font-size: 22px;
    text-align: center;
  }
  .productDetail-info-text-descr {
    font-size: 12px;
    text-align: center;
  }
  .productDetail-info img {
    width: 100%;
  }
  .productDetail-characteristics {
    padding: 0;
  }
  .productDetail-characteristics-title {
    font-size: 22px;
  }
  .productDetail-characteristics-list {
    width: 100%;
  }
  .productDetail-characteristics-list-item {
    width: 95%;
  }
  .productDetail-slider {
    padding: 0 0 20px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProductDetailPage/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;AAEJ;AADI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAGN;AAFM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAIR;AAFM;EACE,aAAA;EACA,sBAAA;AAIR;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAKV;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAKV;AAHQ;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAKV;AAJU;EACE,qBAAA;AAMZ;AAJU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAMZ;AAHQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAKV;AAJU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAMZ;AALY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAOd;AALY;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAOd;AAAE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAEJ;AADI;EACE,aAAA;EACA,sBAAA;AAGN;AAFM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAIR;AAFM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAIR;AADI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAGN;AAAE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AADI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAGN;AADI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AAIR;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAKV;AAHQ;EACE,6BAAA;AAKV;AAFM;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAHQ;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAKV;AAJU;EACE,eAAA;EACA,cAAA;AAMZ;AAAE;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAEJ;AADI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGN;AADI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGN;;AAEA;EAEI;IACE,YAAA;EAAJ;EACI;IACE,eAAA;IACA,sBAAA;IACA,2BAAA;EACN;EAAM;IACE,YAAA;IACA,aAAA;EAER;EACQ;IACE,gBAAA;IACA,eAAA;IACA,kBAAA;EACV;EACQ;IACE,eAAA;IACA,kBAAA;EACV;EACQ;IACE,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EACV;EAIE;IACE,sBAAA;IACA,mBAAA;EAFJ;EAIM;IACE,eAAA;IACA,kBAAA;EAFR;EAIM;IACE,eAAA;IACA,kBAAA;EAFR;EAKI;IACE,WAAA;EAHN;EAME;IACE,UAAA;EAJJ;EAKI;IACE,eAAA;EAHN;EAKI;IACE,WAAA;EAHN;EAIM;IACE,UAAA;EAFR;EAME;IACE,mBAAA;EAJJ;AACF","sourcesContent":[".productDetail {\n  width: 100%;\n  &-bgImage {\n    width: 100%;\n    height: 100vh;\n    background-image: url(\"../../assets/images/fon.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    &-content {\n      height: 80%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      & img {\n        width: 450px;\n        height: 450px;\n        object-fit: contain;\n      }\n      &-right {\n        display: flex;\n        flex-direction: column;\n        &-title {\n          font-size: 36px;\n          font-weight: 700;\n          color: #fefefe;\n          max-width: 615px;\n        }\n        &-descr {\n          font-size: 16px;\n          font-weight: 400;\n          color: #fefefe;\n          opacity: 0.8;\n          max-width: 616px;\n          margin-top: 24px;\n        }\n        & button {\n          margin-top: 32px;\n          border-radius: 20px;\n          padding: 12px 24px;\n          border: 0;\n          outline: none;\n          background-color: #6E00FF;\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n          & a {\n            text-decoration: none;\n          }\n          & span {\n            font-size: 16px;\n            font-weight: 500;\n            color: #fefefe;\n            margin-right: 10px;\n          }\n        }\n        &-colors {\n          display: flex;\n          align-items: center;\n          margin-top: 48px;\n          &-item {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin-right: 24px;\n            &-circle {\n              width: 36px;\n              height: 36px;\n              border-radius: 50%;\n              border: 3px solid #4d4c4d;\n            }\n            & span {\n              margin-top: 10px;\n              font-size: 14px;\n              font-weight: 500;\n              color: #fefefe;\n            }\n          }\n        }\n      }\n    }\n  }\n  &-info {\n    padding: 60px 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &-text {\n      display: flex;\n      flex-direction: column;\n      &-title {\n        font-size: 36px;\n        font-weight: 700;\n        color: #fefefe;\n        max-width: 615px;\n      }\n      &-descr {\n        font-size: 18px;\n        font-weight: 400;\n        color: #fefefe;\n        opacity: 0.8;\n        max-width: 616px;\n        margin-top: 24px;\n      }\n    }\n    & img {\n      width: 615px;\n      height: 500px;\n      border-radius: 12px;\n      object-fit: contain;\n    }\n  }\n  &-characteristics {\n    padding: 60px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    &-title {\n      font-size: 36px;\n      font-weight: 700;\n      color: #fefefe;\n    }\n    &-list {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-top: 24px;\n      &-item {\n        width: 100%;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 1px solid #434242;\n        & span {\n          font-size: 16px;\n          font-weight: 400;\n          color: #ffffff;\n          opacity: 0.8;\n        }\n        &:first-child {\n          border-top: 1px solid #434242;\n        }\n      }\n      & button {\n        margin-top: 30px;\n        padding: 12px 24px;\n        border-radius: 20px;\n        border: 1px solid #fefefe;\n        background-color: transparent;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        & span {\n          margin-left: 10px;\n          font-size: 16px;\n          font-weight: 500;\n          color: #fefefe;\n          &:first-child {\n            font-size: 24px;\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n  &-slider {\n    width: 100%;\n    padding: 100px 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    &-title {\n      font-size: 32px;\n      font-weight: 700;\n      color: #fefefe;\n      text-align: center;\n    }\n    &-descr {\n      margin-top: 16px;\n      font-size: 14px;\n      font-weight: 400;\n      color: #898989;\n      text-align: center;\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .productDetail {\n    &-bgImage {\n      height: auto;\n      &-content {\n        padding: 20px 0;\n        flex-direction: column;\n        justify-content: flex-start;\n        & img {\n          width: 150px;\n          height: 150px;\n        }\n        &-right {\n          &-title {\n            margin-top: 10px;\n            font-size: 22px;\n            text-align: center;\n          }\n          &-descr {\n            font-size: 12px;\n            text-align: center;\n          }\n          & button {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n      }\n    }\n    &-info {\n      flex-direction: column;\n      padding: 30px 0 0 0;\n      &-text {\n        &-title {\n          font-size: 22px;\n          text-align: center;\n        }\n        &-descr {\n          font-size: 12px;\n          text-align: center;\n        }\n      }\n      & img {\n        width: 100%;\n      }\n    }\n    &-characteristics {\n      padding: 0;\n      &-title {\n        font-size: 22px;\n      }\n      &-list {\n        width: 100%;\n        &-item {\n          width: 95%;\n        }\n      }\n    }\n    &-slider {\n      padding: 0 0 20px 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
